import { useContext } from 'react'
import { AuthContext } from '@/features/auth/model/AuthContext'

export const useAuth = () => {
  const ctx = useContext(AuthContext)
  if (!ctx)
    throw new Error('useAuth must be used inside <AuthProvider>')
  return ctx
}
